module.exports = __webpack_public_path__ + "static/media/combobluepad.6ee44d37.jpg";